import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel, SearchPanel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutReverseSettlementCheck extends Layout {
    buttonReverseChecks: Button;
    horizontalspacer1: HorizontalSpacer;
    labelCheckDateTo: Label;
    labelCheckNumberTo: Label;
    panelProcessLog: Panel;
    panelSearchFields: Panel;
    searchpanelReverseSettlementCheck: SearchPanel;
    sourceNonVoidedDrsChecks: DataSource;
    tableChecks: Table;
    textboxBankAccountIdSearch: Textbox;
    textboxCheckDateFrom: Textbox;
    textboxCheckDateTo: Textbox;
    textboxCheckNumberFrom: Textbox;
    textboxCheckNumberTo: Textbox;
    textboxFactoringCompanyIdSearch: Textbox;
    textboxPayeeIdSearch: Textbox;
    textboxVoidDate: Textbox;
}
